export const apiPath = '/v2/activities';
const actionType = 'ACTIVITY';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
